// src/admin/pages/AdminMessages.js
import React, { useState, useEffect, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminMessages, deleteAdminMessage } from "../../services/adminMessages.api";

function AdminMessages() {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const { lang } = useContext(AdminLanguageContext);

    const TEXT = {
        EN: {
            title: "Support Tickets",
            all: "All Tickets",
            open: "Open",
            pending: "Pending",
            closed: "Closed",
            user: "User",
            subject: "Subject",
            status: "Status",
            lastMessage: "Last Message",
            date: "Date",
            view: "View",
            viewTicket: "View Ticket",
            loading: "Loading tickets...",
            empty: "No tickets found.",
        },
        AR: {
            title: "تذاكر الدعم",
            all: "كل التذاكر",
            open: "مفتوحة",
            pending: "قيد الانتظار",
            closed: "مغلقة",
            user: "المستخدم",
            subject: "الموضوع",
            status: "الحالة",
            lastMessage: "آخر رسالة",
            date: "التاريخ",
            view: "عرض",
            viewTicket: "عرض التذكرة",
            loading: "جاري تحميل التذاكر...",
            empty: "لا توجد تذاكر.",
        },
    }[lang];

    const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";

const canAccess = isAdmin || perms.can_manage_messages;


    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState("All");

   useEffect(() => {
  if (!canAccess) return;

  async function load() {
    try {
      setLoading(true);
      const list = await getAdminMessages();
      setTickets(list);
    } finally {
      setLoading(false);
    }
  }

  load();
}, [canAccess]);


const mapStatus = (s) => {
  if (s === "new") return "open";
  if (s === "in_progress") return "pending";
  return "closed"; // resolved/closed
};

    const filtered = tickets.filter((t) =>
  statusFilter === "All"
    ? true
    : mapStatus(t.status) === statusFilter
);

    const getStatusBadge = (status) => {
        if (status === "open")
            return (
                <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 text-sm">
                    {TEXT.open}
                </span>
            );

        if (status === "pending")
            return (
                <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-sm">
                    {TEXT.pending}
                </span>
            );

        return (
            <span className="px-3 py-1 rounded-full bg-gray-300 text-gray-700 text-sm">
                {TEXT.closed}
            </span>
        );
    };

    return (
        <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className="flex-1 lg:ml-64 transition-all duration-300">
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">
  {!canAccess && (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "ليس لديك صلاحية للوصول إلى الرسائل"
          : "You do not have permission to access messages."}
      </p>
    </div>
  )}

  {canAccess && (
    <>


                    <h1 className="text-2xl font-bold text-cyan-700 mb-6 flex items-center gap-2">
                        <FaEnvelope /> {TEXT.title}
                    </h1>

                    {/* FILTER */}
                    <div className="flex flex-col sm:flex-row gap-4 mb-4 max-w-xs">
                        <select
                            className="p-3 border rounded-xl bg-white shadow"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option value="All">{TEXT.all}</option>
                            <option value="open">{TEXT.open}</option>
                            <option value="pending">{TEXT.pending}</option>
                            <option value="closed">{TEXT.closed}</option>
                        </select>
                    </div>

                    {/* DESKTOP TABLE */}
                    <div className="hidden md:block bg-white shadow-lg rounded-xl overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full table-fixed">
                                <thead className="bg-gray-200 text-gray-700">
                                    <tr>
                                       <th className="p-3 text-left">{TEXT.user}</th>
                                       <th className="p-3 text-left">Phone</th>
                                       <th className="p-3 text-left">Email</th>
                                       <th className="p-3 text-left">{TEXT.subject}</th>
                                        <th className="p-3 text-left">{TEXT.status}</th>
                                        <th className="p-3 text-left">{TEXT.lastMessage}</th>
                                        <th className="p-3 text-left">{TEXT.date}</th>
                                        <th className="p-3 text-center">{TEXT.view}</th>
                                        <th className="p-3 text-center">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="8" className="p-4 text-center">
                                                {TEXT.loading}
                                            </td>
                                        </tr>
                                    ) : filtered.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="p-4 text-center">
                                                {TEXT.empty}
                                            </td>
                                        </tr>
                                    ) : (
                                        filtered.map((t) => (
                                            <tr key={t.id} className="border-b hover:bg-gray-50">
                                                <td className="p-3 font-semibold">{t.full_name}</td>
                                                <td className="p-3 text-gray-700 max-w-[140px] truncate">
                                                  {t.phone || "—"}
                                                </td>
                                                <td className="p-3 text-gray-700 max-w-[200px] truncate">
                                                  {t.email ? t.email : "—"}
                                                </td>
                                                <td className="p-3 max-w-[180px] truncate">{t.subject}</td>
                                                <td className="p-3">{getStatusBadge(mapStatus(t.status))}</td>
                                                <td className="p-3 text-gray-600 max-w-[260px] truncate">{t.lastMessage}</td>
                                                <td className="p-3">{new Date(t.created_at).toLocaleDateString()}</td>
                                                <td className="p-3 text-center">
                                                    <button
                                                        className="text-cyan-600 hover:text-cyan-800 font-bold"
                                                        onClick={() => navigate(`/admin/messages/${t.id}`)}
                                                    >
                                                        {TEXT.view}
                                                    </button>
                                                </td>
                                                <td className="p-3 text-center">
  <button
    className="text-red-600 hover:text-red-800 font-bold"
    onClick={async () => {
      if (!window.confirm("Delete this message?")) return;

      await deleteAdminMessage(t.id);
      setTickets((prev) => prev.filter((x) => x.id !== t.id));
    }}
  >
    Delete
  </button>
</td>

                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                   {/* MOBILE VIEW */}
<div className="md:hidden space-y-4">
  {loading ? (
    <p className="text-center py-4">{TEXT.loading}</p>
  ) : filtered.length === 0 ? (
    <p className="text-center py-4">{TEXT.empty}</p>
  ) : (
    filtered.map((t) => (
      <div
        key={t.id}
        className="bg-white p-4 rounded-xl shadow border space-y-3"
      >
        {/* HEADER: NAME + STATUS */}
        <div className="flex items-center justify-between">
          <p className="font-semibold text-base">{t.full_name}</p>
          {getStatusBadge(mapStatus(t.status))}
        </div>

        {/* CONTACT INFO */}
        {(t.phone || t.email) && (
          <div className="text-sm text-gray-600 space-y-1">
            {t.phone && <p>📞 {t.phone}</p>}
            {t.email && <p>✉️ {t.email}</p>}
          </div>
        )}

        {/* SUBJECT */}
        <p className="text-sm">
          <span className="font-semibold">{TEXT.subject}:</span>{" "}
          {t.subject}
        </p>

        {/* LAST MESSAGE */}
        <p className="text-sm text-gray-600 line-clamp-2">
          {t.lastMessage}
        </p>

        {/* FOOTER */}
        <div className="flex items-center justify-between pt-2 border-t text-xs text-gray-500">
          <span>
            {new Date(t.created_at).toLocaleDateString()}
          </span>

          <button
            className="text-cyan-600 font-semibold hover:text-cyan-800"
            onClick={() => navigate(`/admin/messages/${t.id}`)}
          >
            {TEXT.viewTicket}
          </button>
        </div>
      </div>
    ))
  )}
</div>
           </>
  )}

                </main>
         

            </div>
        </div>
    );
}

export default AdminMessages;
